import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Auth from './pages/Auth';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import AIConsulting from './pages/AIConsulting';
import CustomAISolutions from './pages/CustomAISolutions';
import Packages from './pages/Packages';
import DashboardPackages from './pages/DashboardPackages';

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-nvidia-dark-800 via-nvidia-dark to-nvidia-dark-800 text-white">
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#252525',
            color: '#fff',
            border: '1px solid #333333',
          },
        }}
      />
      <Navbar />
      <main className="flex-grow">
        <div className="min-h-[calc(100vh-4rem)] bg-gradient-radial from-nvidia-dark-700/50 via-transparent to-transparent">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/dashboard/packages" element={<DashboardPackages />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/ai-consulting" element={<AIConsulting />} />
            <Route path="/custom-ai-solutions" element={<CustomAISolutions />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;
